import { render, staticRenderFns } from "./LprTriggerUpdatePlateHistory.vue?vue&type=template&id=6c92380e&"
import script from "./LprTriggerUpdatePlateHistory.vue?vue&type=script&lang=js&"
export * from "./LprTriggerUpdatePlateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports